import './styles.css';

export default function ReviewSessionCompetitionHeader({
  title,
  description
}) {
  return (
    <div className="onboarding-review-session-header">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
};